import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 27 27",
  class: "jl2-custom-filled-icon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-miterlimit": "10",
      d: "M13.5 26.16c6.904 0 12.5-5.596 12.5-12.5 0-6.903-5.596-12.5-12.5-12.5S1 6.757 1 13.66c0 6.904 5.596 12.5 12.5 12.5Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      class: "content",
      d: "M17.899 19.96a.57.57 0 0 1-.39-.16l-4.01-3.85-4.01 3.85a.57.57 0 0 1-.39.16c-.08 0-.15-.02-.22-.04a.557.557 0 0 1-.34-.52V7.83c0-.26.21-.46.46-.46h9c.26 0 .46.21.46.46V19.4c0 .22-.13.43-.34.52-.07.03-.14.04-.22.04Zm-8.44-1.43 3.65-3.5c.11-.1.24-.16.39-.16.15 0 .28.06.39.16l3.65 3.5V8.29H9.47v10.24h-.01Z"
    }, null, -1)
  ])))
}